import { getGameParticipantName } from '../participant'
import { isDummyParticipant, getDummyParticipantSeed } from './displayRounds'
import { type GameParticipantId, type DecoratedGameParticipant, isNotDefined, isDefined } from '@terros/common'

type ParticipantTextProps = {
  participantId: GameParticipantId | undefined
  participant: DecoratedGameParticipant | undefined
  round: number
  isByeMatch?: boolean
}
export const getParticipantText = ({ participantId, participant, round, isByeMatch }: ParticipantTextProps): string => {
  if (isByeMatch && isNotDefined(participantId)) return 'Bye'
  if (participantId && isDummyParticipant(participantId)) return getDummyParticipantSeed(participantId)
  if (isDefined(participant)) return getGameParticipantName(participant)
  return getText(round)
}

const getText = (round: number): string => {
  if (round === 1) return 'No match this round'
  return `Winner of Round ${round - 1}`
}
